<template>
  <div class="cont-prez">
    <b-skeleton v-if="!loaded" width="50px" height="30px" />
    <div class="prezzi-elm"  v-if="loaded">
      <ul  v-if="priceFound && scaglioni.length <= 3">
        <li v-for="(scaglione, index) in scaglioni" >
          <span v-if="scaglioni.length > 1 && scaglione.qta > 0 " class="quantita"> > {{ scaglione.qta }} {{parseUnitaMisura}} </span>
          <span v-if="scaglioni.length > 1 && scaglione.qta === 0 " class="quantita"> 1 {{ trans.get('b2b.cart.pack')}} </span>
          <span class="importo"> {{ scaglione.prezzoNetto.toLocaleString('it-IT', {minimumFractionDigits: 3}) }}€/{{parseUnitaMisura}} </span>
        </li>
      </ul>
      <div class="scaglioni-pop-up" v-if="priceFound && scaglioni.length > 3">
        <span class="prezzo-metratura" >{{ trans.get("b2b.prices.price-per-meter") }}</span>
        <div class="pop-up-wrapper">
          <i class="fas fa-info-circle"></i>
          <div class="pop-up">
            <ul  v-if="priceFound">
              <li v-for="(scaglione, index) in scaglioni">
                <span  class="quantita"> > {{ scaglione.qta }} {{parseUnitaMisura}} </span>
                <span v-if="scaglione.qta > 0 " class="quantita"> > {{ scaglione.qta }} {{parseUnitaMisura}} </span>
                <span v-if="scaglione.qta === 0 " class="quantita"> 1 {{ trans.get('b2b.cart.pack')}} </span>
                <span class="importo"> {{ scaglione.prezzoNetto.toLocaleString('it-IT', {minimumFractionDigits: 3}) }}€/{{parseUnitaMisura}} </span>
              </li>
            </ul>
            <div class="triangle"></div>
          </div>
        </div>


      </div>
      <span v-if="!priceFound">{{ trans.get("b2b.prices.not-found") }} <span class="d-none">{{parseUnitaMisura}}</span></span>
    </div>
  </div>
</template>

<script>
export default {
    props: ['cod_art', 'current_user', 'unita_misura'],
  data() {
    return {
      priceFound: false,
      scaglioni: null,
      loaded: false,
    }
  },
  mounted() {
      this.getPrices()
  },
  computed: {
      parseUnitaMisura(){
        let parsed = null
        if (this.unita_misura === 'ML'){
          parsed = 'Mt'
        } else if (this.unita_misura === 'NR' || this.unita_misura === 'PZ'){
          parsed = this.$trans('b2b.prices.pcs')
        }
        this.$emit('unita-misura', parsed)
        return parsed
      },
  },
  methods: {
    /*getUnitaMisura (){
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/getUnitaMisura',
        params: {
          cod_art: this.cod_art
        }
      }).then(res => {
        //console.log(res.data[0])
        if (res.data[0] === 'ML'){
          this.unita_misura = 'Mt'
        } else if (res.data[0] === 'NR'|| res.data[0] === 'PZ'){
          this.unita_misura = this.$trans('b2b.prices.pcs')

        }
        this.$emit('unita-misura', this.unita_misura)
      }).catch(err => {
        console.log(err.response.data.message)
      })
    },*/
    getPrices: function () {
      axios({
        method: "post",
        url: window.location.origin + "/b2b/prezzi",
        params: {
          codart: this.cod_art,
          codcliente: this.current_user,
        },
      })
          .then((res) => {
           if (res.data){
             if (res.data[0].scaglioni.length !== 0 && res.data[0].scaglioni[0].prezzoNetto > 0) {
               this.priceFound = true
               this.scaglioni = res.data[0].scaglioni;
               this.$emit('prezzi', {scaglioni: this.scaglioni, priceFound: this.priceFound})
               if (res.data[0].storicoAcquistato.length > 0) {
                 this.$emit('storicoAcquistato', res.data[0].storicoAcquistato)
               }

             } else {
               this.priceFound = false
               this.$emit('prezzi', {scaglioni: null, priceFound: this.priceFound})
               if (res.data[0].storicoAcquistato.length > 0) {
                 this.$emit('storicoAcquistato', res.data[0].storicoAcquistato)
               }
             }
             this.loaded = true
           }
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          })
    },
  },
}
</script>

<style lang="scss" scoped>
 .cont-prez {
   height: 70px;
   width: 100%;
   display: flex;
   .prezzi-elm {
     width: 100%;
     height: 100%;
     ul, .scaglioni-pop-up .pop-up ul {
       display: flex;
       flex-direction: column;
       padding-right: 20px;
       width: 100%;
       li{
         width: 100%;
         display: flex;
         justify-content: space-between;

       }
     }
     &.multiple{
       margin-top: auto;
     }
     &.single{
       margin-top: 0;
     }
     .scaglioni-pop-up {

         &:hover .pop-up-wrapper .pop-up  {
           display: block;
         }


       .prezzo-metratura{
         text-decoration: underline;
       }
       .pop-up-wrapper {
         display: inline-block;
         position: relative;
         i{
           filter: invert(1);
         }

         .pop-up {
           display: none;
           filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.45));
           background-color: #fff;
           position: absolute;
           bottom: 59px;
           right: -91px;

           ul {
             width: 200px;
             padding: 20px 10px;
           }
           .triangle {
             position: absolute;
             transform: translate(-50%);
             top: 100%;
             left: 50%;
             width: 0;
             height: 0;
             border-left: 10px solid transparent;
             border-right: 10px solid transparent;

             border-top: 40px solid #fff;
           }
         }
       }


     }
   }
  width: 100%;
   .importo, .quantita {
     font-size: 14px;
     white-space: nowrap;

   }
 }
</style>
